import Http from 'axios'
import {
    API_URL, VERSIONED_API_URL,
    VERSION
} from '../../../config/config'

import {buildFormData} from "../../../helpers/FormedData";

function initialState() {
//    var today=(new Date()).toISOString().substring(0,10);
    return {
        loading: false,
        countries:[],
        travellerData:{
            id:null,
            visa_number: "",
            passport_number: "",
            dob: "",
            country_id:'',
            full_name: '',
            occupation: '',
            contact_number: '',
            email:null,
            user:{},
            passport:{
                passport_image:{},
            },
        },
        visaData:{},
        visaTypes:[],
        visaConditions:[],
    }
}

const getters = {
    loading: state => state.loading,
    visaData: state => state.visaData,
    travellerData: state => state.travellerData,
    countries: state => state.countries,
};

const actions = {


    // checkVisaEntryValidity({commit, state}) {
    //     let formData = new FormData();
        //     buildFormData(formData, state.travellerData);
    //     buildFormData(formData, state.visaData);
    //     return new Promise((resolve, reject) => {
    //         Http.post(API_URL + VERSION + '/visa/entry/confirm', formData)
    //             .then(response => {
    //                 commit('setTrekkingRequestDetails', response.data)
    //                 commit('setLoading', false)
    //                 resolve(response)
    //             })
    //             .catch(error => {
    //                 commit('setLoading', false)
    //                 reject(error)
    //             })
    //     });
    // },
    createVisaEntry({commit, state}) {
        let formData = new FormData();
        buildFormData(formData, state.travellerData);
        buildFormData(formData, state.visaData);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa/entry', formData)
                .then(response => {
                    commit('setTrekkingRequestDetails', response.data)
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    createNewTraveller({commit, state}) {
        let formData = new FormData();
        buildFormData(formData, state.travellerData);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/traveller/new/entry', formData)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response);
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    getCountries({commit}) {
        Http.get(VERSIONED_API_URL + "/countries/fetch-all")
            .then(response => {
                commit('setCountries', response.data.data);
            })
    },

    getVisaTypeCondition({commit},params) {
        Http.get(`${VERSIONED_API_URL}/visa-type-condition`,params)
            .then((res)=>{
                commit("setVisaConditions",res.data.conditions);
            })
            .catch(()=>{
                this.$store.commit("Notification/showError", 'Something went wrong');
            })
    },

    getVisaTypeConditionAll({commit}) {
        Http.get(`${VERSIONED_API_URL}` + `/visa/mve-eat-migration-conditions/all`)
            .then((res)=>{
                commit("setVisa",res.data.data);
            })
            .catch(()=>{
                this.$store.commit("Notification/showError", 'Something went wrong');
            })
    },
};

const mutations = {
    setVisaData(state, item) {
        state.visaData = item;
    },
    setTravellerData(state, items) {
        state.travellerData = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState());
    },
    setCountries(state, country) {
        state.countries = country;
    },
    setVisa(state, types){
        state.visaTypes = types;
    },
    setVisaConditions(state, types){
        state.visaConditions = types;
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
